import client from './client';
import type { AuditLogEntry, PaginatedResponse, PaginationParams } from '@/types';

export interface AuditLogListParams extends PaginationParams {
  action?: string;
  resource_type?: string;
}

export async function fetchAuditLogs(params?: AuditLogListParams) {
  const { data } = await client.get<PaginatedResponse<AuditLogEntry>>('/audit-logs/', {
    params,
  });
  return data;
}
